import { Block } from "../types";
import { isManualProcess, shouldSkipReferenceApi } from "../../../utils/processTypeUtils";

export function isManuallyAddedBlock(block: Block): boolean {
  const source = block.meta?.source;
  return source === "manual" || source === "palette";
}

/** Bloc issu de la génération IA (pas palette, pas post-it pain_points, pas start/end/note). */
export function isGeneratedBlock(block: Block): boolean {
  if (block.type === "start" || block.type === "end" || block.type === "note") return false;
  if (isManuallyAddedBlock(block)) return false;
  if (block.meta?.source === "pain_points") return false;
  return true;
}

export interface WarningEligibilityContext {
  processType: string;
  isSampleProcess: boolean;
}

/** Pastilles d'avertissement : processus AI interview + blocs générés uniquement. */
export function isWarningEligibleBlock(
  block: Block,
  { processType, isSampleProcess }: WarningEligibilityContext,
): boolean {
  if (isSampleProcess) return false;
  if (isManualProcess(processType) || shouldSkipReferenceApi(processType)) return false;
  return isGeneratedBlock(block);
}
